module.exports = __webpack_public_path__ + "static/media/reporting.ca0c7745.svg";